import { ChevronDown, Download, FileText } from "lucide-react";

import { Button } from "./button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";

interface ExportDropdownProps {
  onExport: (format: "docx" | "pdf") => void | Promise<void>;
  label?: string;
  disabled?: boolean;
}

/**
 * Reusable Word/PDF export dropdown. Two consumers in Sprint A:
 * the document-level "Preuzmi" button and the per-section export.
 */
export function ExportDropdown({
  onExport,
  label = "Preuzmi",
  disabled,
}: ExportDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled}>
          <Download className="h-3.5 w-3.5" />
          {label}
          <ChevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => void onExport("docx")}>
          <FileText className="h-4 w-4" /> Word (.docx)
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => void onExport("pdf")}>
          <FileText className="h-4 w-4" /> PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
